export enum HeaderVariant {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
}
